import React from 'react';

class About extends React.Component {

    render() {
        return (
            <React.Fragment>
                <div className="container" id="about">
                    <div className="row">
                        <div className="col-12">
                            <h1 className="section-title">About</h1>
                                <p>I’m an Artificial Intelligence graduate from the University of Malta and a Senior Frontend Developer with experience leading development teams at Dorado Games. I specialise in building and scaling live game features, contributing to online experiences enjoyed by millions of players worldwide.</p>
                                <p>I’ve led small, fully-remote teams, coordinated development efforts across departments, and worked closely with production to deliver high-quality features in fast-paced environments. My work has focused on performance, reliability, and creating smooth player experiences, while maintaining strong code quality and technical standards.
                                I thrive in collaborative settings, enjoy solving complex problems, and adapt quickly to new challenges and technologies.</p>
                                <p>Outside of work, I explore creative outlets such as pottery, leathermaking, reading, gaming, and taking part in theatrical performances.</p>
                        </div>
                        <div className="col-12">
                            <h3>Technical Skills</h3>
                            <h4>Proficient</h4>
                            <p>Typescript &#x2022; JavaScript &#x2022; React  &#x2022; Redux &#x2022; VueJS &#x2022; Webpack &#x2022; Git &#x2022; PHP &#x2022; Java &#x2022; HTML &#x2022; SCSS &#x2022; Bootstrap &#x2022; Unity &#x2022; P/NPM  &#x2022; Wordpress &#x2022; API integrations &#x2022; SEO Optimization &#x2022; AI-Assisted Development (ChatGPT, Copilot, Claude)</p>
                            <h4>Other</h4>
                            <p>PixiJS &#x2022; Jenkins (CD/CI) &#x2022; SQL &#x2022; C++ &#x2022; Unreal &#x2022; Vite &#x2022; Pootle &#x2022; Node.js &#x2022; Jest  &#x2022; Docker &#x2022; MongoDB &#x2022; Bash</p>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        )
    }
}

export default About;
